import React from "react";
import { textCase } from "../../../../service/ui/UI";
import AppTranslation from "../../../../service/app_translation/AppTranslation";
import { ChatFooterWarning } from "./ConversationFooters";

export const GroupChatExitFooter = () => {
  return (
    <ChatFooterWarning>
      {AppTranslation.text("group_no_longer_a_member")}
    </ChatFooterWarning>
  );
};

export const GroupChatNoAccessFooter = () => {
  return (
    <ChatFooterWarning>
      <span>{textCase("only ")}</span>
      <span role="button" className="font-gotham-bold">
        {textCase("admins")}
      </span>
      <span>{textCase(" can send messages ")}</span>
      <span>{textCase("only ")}</span>
    </ChatFooterWarning>
  );
};
